module.exports = __webpack_public_path__ + "img/Superb_sword_15.e3fcceb5.png";